import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {BankTransferSettingsForm} from './components/BankTransferSettingsForm';

export function BankTransferSettings() {
  return (
    <SettingsTemplate
      header={{
        title: i18n.t('entity.settings.bankTransfer.labels.pageTitle'),
      }}
      data-testid="settings-bankTransfer"
    >
      <BankTransferSettingsForm />
    </SettingsTemplate>
  );
}
